import React, { useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";

const permissionsData = [
  { id: 1, name: "view_dashboard", userTypes: ["Student", "Mentor", "School"] },
  { id: 2, name: "edit_profile", userTypes: ["Student", "Mentor"] },
  { id: 3, name: "upload_assignment", userTypes: ["Kids", "Student"] },
  { id: 4, name: "view_reports", userTypes: ["Mentor", "School"] },
  { id: 5, name: "add_comment", userTypes: ["Student", "Kids"] },
  { id: 6, name: "delete_post", userTypes: ["Mentor", "School"] },
  { id: 7, name: "submit_homework", userTypes: ["Kids", "Student"] },
  { id: 8, name: "create_class", userTypes: ["Mentor", "School"] },
  { id: 9, name: "join_meeting", userTypes: ["Student", "Mentor", "Kids"] },
  { id: 10, name: "moderate_chat", userTypes: ["Mentor", "School"] },
  { id: 11, name: "play_game", userTypes: ["Kids"] },
  { id: 12, name: "assign_teacher", userTypes: ["School"] },
  { id: 13, name: "request_certificate", userTypes: ["Student", "School"] },
  { id: 14, name: "manage_tasks", userTypes: ["Mentor"] },
  { id: 15, name: "view_score", userTypes: ["Kids", "Student"] },
  { id: 16, name: "upload_notice", userTypes: ["School", "Mentor"] },
  { id: 17, name: "join_quiz", userTypes: ["Student", "Kids"] },
  { id: 18, name: "create_module", userTypes: ["Mentor", "School"] },
  { id: 19, name: "watch_video", userTypes: ["Kids", "Student"] },
  { id: 20, name: "approve_leave", userTypes: ["School"] },
  { id: 21, name: "assign_quiz", userTypes: ["Mentor", "School"] },
  { id: 22, name: "submit_quiz", userTypes: ["Student", "Kids"] },
  { id: 23, name: "manage_schedule", userTypes: ["School", "Mentor"] },
  { id: 24, name: "ask_question", userTypes: ["Student", "Kids"] },
  { id: 25, name: "grade_assignment", userTypes: ["Mentor"] },
  { id: 26, name: "draw_shape", userTypes: ["Kids"] },
  { id: 27, name: "create_event", userTypes: ["School", "Mentor"] },
  { id: 28, name: "submit_project", userTypes: ["Student"] },
  { id: 29, name: "view_students", userTypes: ["Mentor", "School"] },
  { id: 30, name: "practice_abc", userTypes: ["Kids"] },
  { id: 31, name: "manage_fees", userTypes: ["School"] },
  { id: 32, name: "view_lessons", userTypes: ["Student", "Mentor"] },
  { id: 33, name: "host_webinar", userTypes: ["Mentor", "School"] },
  { id: 34, name: "color_pictures", userTypes: ["Kids"] },
  { id: 35, name: "generate_report", userTypes: ["School"] },
  { id: 36, name: "take_test", userTypes: ["Student", "Kids"] },
  { id: 37, name: "assign_homework", userTypes: ["Mentor"] },
  { id: 38, name: "solve_puzzle", userTypes: ["Kids", "Student"] },
  { id: 39, name: "track_attendance", userTypes: ["School", "Mentor"] },
  { id: 40, name: "join_forum", userTypes: ["Student"] },
  { id: 41, name: "manage_forum", userTypes: ["Mentor", "School"] },
  { id: 42, name: "listen_song", userTypes: ["Kids"] },
  { id: 43, name: "schedule_meeting", userTypes: ["School", "Mentor"] },
  { id: 44, name: "watch_lesson", userTypes: ["Student", "Kids"] },
  { id: 45, name: "review_project", userTypes: ["Mentor"] },
  { id: 46, name: "build_blocks", userTypes: ["Kids"] },
  { id: 47, name: "assign_roles", userTypes: ["School"] },
  { id: 48, name: "explore_topic", userTypes: ["Student", "Kids"] },
  { id: 49, name: "share_feedback", userTypes: ["Mentor", "Student"] },
  { id: 50, name: "give_star", userTypes: ["Mentor", "Kids", "School"] },
];

const userTypes = ["Student", "Mentor", "School", "Kids"];

const UserMangement = () => {
  const [checkedPermissions, setCheckedPermissions] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  const handleCheckboxChange = (userType, permissionName, isChecked) => {
    setCheckedPermissions((prev) => {
      const current = new Set(prev[userType] || []);
      isChecked ? current.add(permissionName) : current.delete(permissionName);
      return { ...prev, [userType]: Array.from(current) };
    });
  };

  const handleSelectAll = (userType, permissions) => {
    const allVisible = permissions.map((p) => p.name);
    const alreadyAllSelected =
      checkedPermissions[userType]?.filter((p) => allVisible.includes(p)).length === allVisible.length;

    setCheckedPermissions((prev) => ({
      ...prev,
      [userType]: alreadyAllSelected ? [] : Array.from(new Set(allVisible)),
    }));
  };

  const isChecked = (userType, permissionName) =>
    checkedPermissions[userType]?.includes(permissionName) || false;

  const filteredPermissions = (userType) =>
    permissionsData.filter(
      (perm) =>
        perm.userTypes.includes(userType) &&
        perm.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSave = (userType) => {
  const selected = checkedPermissions[userType] || [];
  console.log(`Saving permissions for ${userType}:`, selected);

  // 🛠️ Here you can replace with API call to save
  // Example: axios.post(`/api/save-permissions`, { userType, permissions: selected })
};


  return (
    <AdminAppBody
      content={
        <div className="container mt-4">
          <div className="mb-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search permission..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {userTypes.map((userType) => {
            const permissions = filteredPermissions(userType);
            const allSelected =
              permissions.length > 0 &&
              permissions.every((p) => isChecked(userType, p.name));

            if (permissions.length === 0) return null;

            return (
              <div key={userType} className="mb-4 border p-3 rounded shadow-sm bg-light">
                <div className="col-12 d-flex justify-content-between align-items-center mb-2">
                  <h5 className="text-primary m-0">{userType}</h5>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => handleSelectAll(userType, permissions)}
                  >
                    {allSelected ? "Unselect All" : "Select All"}
                  </button>
                </div>
                <div className="row">
                  {permissions.map((perm) => (
                    <div key={perm.id} className="col-4 mb-2">
                      <label className="form-check-label">
                        <input
                          type="checkbox"
                          className="form-check-input me-2"
                          checked={isChecked(userType, perm.name)}
                          onChange={(e) =>
                            handleCheckboxChange(userType, perm.name, e.target.checked)
                          }
                        />
                        {perm.name}
                      </label>
                      
                    </div>
                  ))}
                <div className="col-12"> 
                  <div className="row">
                    <div className="col-9"></div>
                   <div className="col-3 "> <button
        className="btn btn-sm btn-success ms-5 mt-2 mb-2"
        onClick={() => handleSave(userType)}
      >
        Save {userType} Permissions
      </button></div>
                    </div></div>
                 </div>

              </div>
            );
          })}
        </div>
      }
    />
  );
};

export default UserMangement;
